"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const context_1 = require("../../../../context");
const react_2 = require("@osmosys/react");
const react_hanger_1 = require("react-hanger");
const react_if_1 = require("react-if");
const react_loops_1 = require("react-loops");
const fuzzy_1 = require("fuzzy");
const react_use_1 = require("react-use");
const hooks_1 = require("../../../../hooks");
exports.WorkspaceNavItem = ({ onWorkspaceChange }) => {
    const { currentUser, currentWorkspace, currentWorkspaceMembership, } = react_1.useContext(context_1.OsmosysAppContext);
    const { mutate, result } = hooks_1.useSetCurrentWorkspaceMembership(onWorkspaceChange);
    const searchInput = react_hanger_1.useInput('');
    const isSearching = searchInput.hasValue;
    const membershipsExcludingCurrent = react_1.useMemo(() => {
        return currentUser.workspaceMemberships.filter(wsm => wsm.id !== currentWorkspaceMembership.id);
    }, [currentUser.workspaceMemberships, currentWorkspaceMembership.id]);
    const [membershipsFiltered, setState] = react_1.useState(membershipsExcludingCurrent);
    react_use_1.useDebounce(() => {
        if (!isSearching) {
            setState(membershipsExcludingCurrent);
        }
        setState(fuzzy_1.filter(searchInput.value ? searchInput.value.trim() : '', membershipsExcludingCurrent, {
            extract: wm => wm.workspace.name,
        }).map(found => found.original));
    }, 200, [isSearching, searchInput.value, membershipsExcludingCurrent]);
    // Show just an icon for users with no workspace:
    if (!currentUser ||
        !currentWorkspace ||
        !currentWorkspaceMembership ||
        !currentUser.workspaceMemberships ||
        currentUser.workspaceMemberships.length === 0) {
        return (react_1.default.createElement(react_2.OsmosysTooltip, { span: true, label: "No workspace" },
            react_1.default.createElement(reactstrap_1.NavItem, { className: "text-muted" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faBuilding }))));
    }
    const building = (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: result.loading ? pro_solid_svg_icons_1.faSpinnerThird : pro_solid_svg_icons_1.faBuilding, spin: result.loading, className: classnames_1.default('mr-md-2') }));
    // Show a single nav for users with just one membership:
    if (currentUser.workspaceMemberships.length === 1 && currentWorkspace) {
        return (react_1.default.createElement(reactstrap_1.NavItem, null,
            react_1.default.createElement(reactstrap_1.NavLink, { className: "text-dark", tag: react_router_dom_1.Link, to: "/workspace" },
                building,
                react_1.default.createElement("span", { className: "d-none d-md-inline" }, currentWorkspace.name))));
    }
    const toggle = (react_1.default.createElement(reactstrap_1.DropdownToggle, { nav: true, className: "text-dark", "data-testid": "workspace-dropdown-toggle" },
        building,
        react_1.default.createElement("span", { className: "d-none d-md-inline" }, currentWorkspace.name)));
    const searchBox = membershipsExcludingCurrent.length > 2 && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reactstrap_1.Input, Object.assign({ placeholder: "Search" }, searchInput.eventBind, { className: "border-0 rounded-0 mb-0 px-3" }))));
    const currentlyAWorkspaceAdmin = currentWorkspaceMembership.isWorkspaceAdmin && (react_1.default.createElement(reactstrap_1.DropdownItem, { tag: react_router_dom_1.Link, to: "/workspace/settings", className: "small text-muted" },
        react_1.default.createElement(react_2.OsmosysTooltip, { span: true, label: "Workspace admin" },
            react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "workspaceAdminsOnly", iconStyle: "solid", size: "sm", className: "mr-1" }),
            ' ',
            "Workspace settings")));
    const currentWorkspaceComp = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reactstrap_1.DropdownItem, { tag: react_router_dom_1.Link, to: "/workspace" },
            react_1.default.createElement(react_2.OsmosysDiv, { osysName: "WorkspaceNavItem.CurrentWorkspace.outer", flexRowFilled: true },
                react_1.default.createElement(react_2.OsmosysDiv, { osysName: "WorkspaceNavItem.CurrentWorkspace.left", flexColCentered: true, marginRight: true },
                    react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "workspace", iconStyle: "solid" })),
                react_1.default.createElement(react_2.OsmosysDiv, { osysName: "WorkspaceNavItem.CurrentWorkspace.center", padding: "x" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("span", { className: "font-weight-bold" }, currentWorkspace.name))))),
        currentlyAWorkspaceAdmin));
    const menu = (react_1.default.createElement(reactstrap_1.DropdownMenu, { right: true },
        react_1.default.createElement(react_if_1.When, { condition: !isSearching },
            currentWorkspaceComp,
            react_1.default.createElement(reactstrap_1.DropdownItem, { divider: true, className: "mb-0" })),
        searchBox,
        react_1.default.createElement(reactstrap_1.DropdownItem, { divider: true, className: "mb-1 mt-0" }),
        react_1.default.createElement("div", { style: { maxHeight: 315, overflow: 'auto' }, className: "pt-2" },
            react_1.default.createElement(react_loops_1.For, { of: membershipsFiltered, ifEmpty: react_1.default.createElement(reactstrap_1.DropdownItem, { disabled: true }, "No results"), as: wsm => {
                    return (react_1.default.createElement(exports.WorkspaceDropdownItem, { key: wsm.id, onSelect: () => {
                            mutate({
                                variables: {
                                    workspaceMembershipId: wsm.id,
                                },
                            });
                        }, workspaceMembership: wsm }));
                } }))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reactstrap_1.UncontrolledDropdown, { nav: true, inNavbar: true },
            toggle,
            menu),
        react_1.default.createElement(react_2.OsmosysAlert, { apolloError: result.error, dismissable: true, floatBottom: true })));
};
exports.WorkspaceDropdownItem = ({ workspaceMembership, onSelect, }) => {
    return (react_1.default.createElement(reactstrap_1.DropdownItem, { onKeyUp: e => {
            if (e.keyCode !== 13) {
                return;
            }
            onSelect();
        }, onClick: onSelect }, workspaceMembership.workspace.name));
};
//# sourceMappingURL=WorkspaceNavItem.js.map